import React from 'react';
import styled from 'styled-components';
import Media from 'react-media';

import { Flex, Text } from '../../../components';

import LogoText from '../../../assets/LogoText.png';
import Instagram from '../../../assets/Instagram.png';
import Twitter from '../../../assets/Twitter.png';

import moment from '../../../utils/MomentConst';

const Container = styled(Flex)`
  padding: 40px 40px;
  margin: 0 auto;
  font-size: 16px;
  position: relative;
`;

const BottomContainer = styled(Container)`
  background: #161930;
  color: #7178b2;
`;

const Link = styled.a`
  color: #7178b2;
  font-weight: 600;
  transition: opacity 200ms;
  &:hover {
    opacity: 0.5;
  }
`;

const Footer = () => (
  <>
    <Media query={{ minWidth: 1100 }}>
      {matches => (
        <Container w="80%" dir={matches ? 'row' : 'column'}>
          <Flex dir="column">
            <img style={{ width: 140 }} src={LogoText} alt="Trickle" />
            <Flex h="20px" />
            <Flex dir="row" align="center">
              <Link href="mailto:contact@trickle.bot" style={{ color: '#33C4FF' }}>
                Email Us
              </Link>
              <Flex w="10px" />
              <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1 1L6.25 6.25L1 11.5"
                  stroke="#33C4FF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Flex>
          </Flex>
          <Flex fg="1" h="40px" />
          <Flex dir="column">
            <Text.Body b>Navigation</Text.Body>
            <Flex h="20px" />
            <Link href="#home">Home</Link>
            <Flex h="15px" />
            <Link href="#features">Features</Link>
            <Flex h="15px" />
            <Link href="#sitelist">Sitelist</Link>
            <Flex h="15px" />
            <Link href="#FAQ">FAQ</Link>
          </Flex>
          <Flex fg="1" h="40px" />
          <Flex dir="column">
            <Text.Body b>Important</Text.Body>
            <Flex h="20px" />
            <Link href="/terms">Terms of Service</Link>
            <Flex h="15px" />
            <Link href="/privacy">Privacy Policy</Link>
          </Flex>
          <Flex fg="1" h="40px" />
          <Flex dir="column">
            <Text.Body b>Socials</Text.Body>
            <Flex h="20px" />
            <Link href="https://instagram.com/tricklebot">
              <Flex dir="row" align="center">
                <img src={Instagram} alt="" />
                <Flex w="10px" />
                <Text.Body>Instagram</Text.Body>
              </Flex>
            </Link>
            <Flex h="20px" />
            <Link href="https://twitter.com/tricklebot">
              <Flex dir="row" align="center">
                <img src={Twitter} alt="" />
                <Flex w="10px" />
                <Text.Body>Twitter</Text.Body>
              </Flex>
            </Link>
          </Flex>
        </Container>
      )}
    </Media>
    <BottomContainer w="100%" align="center" justify="center">
      &copy; Trickle, {moment().year()}
    </BottomContainer>
  </>
);

export default Footer;
